const IconClose = (): JSX.Element => {
  return (
    <>
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M.5,23.5L23.5.5M.5.5l23,23"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  );
};

export default IconClose;
